import { DatePicker } from "antd";
import styled from "styled-components";

export const CustomDatePicker = styled(DatePicker)`
  .ant-picker-input > input {
    text-align: center;
  }
`;
